module.exports = __webpack_public_path__ + "img/code.2699a206.png";